import * as React from 'react';
import { useDayPicker } from "../../contexts";
/** Render the caption for the displayed month. This component is used when `captionLayout="buttons"`. */

export function CaptionLabel(props) {
  var _a = useDayPicker(),
      locale = _a.locale,
      classNames = _a.classNames,
      styles = _a.styles,
      formatCaption = _a.formatters.formatCaption;

  return /*#__PURE__*/React.createElement("div", {
    key: "caption",
    className: classNames.caption_label,
    style: styles.caption_label,
    "aria-live": "polite",
    "aria-atomic": "true"
  }, formatCaption(props.displayMonth, {
    locale: locale
  }));
}